import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { PERFORMANCE_STICK_WITH_IT_MODAL } from 'utils/testing/testIDs'

import {
  ModalContent,
  ModalHeader,
  ModalText,
  StyledModalDrawer,
} from './styled-components'

export const StickWithItModal = ({
  isOpen,
  onDismiss,
}: {
  isOpen: boolean
  onDismiss: () => void
}): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()

  return (
    <StyledModalDrawer
      data-testid={PERFORMANCE_STICK_WITH_IT_MODAL}
      isOpen={isOpen}
      onClose={onDismiss}
    >
      <ModalContent>
        <ModalHeader>
          {getRemoteString({
            key: 'early.recap.performance.negative_gain.drawer.header',
          })}
        </ModalHeader>
        <ModalText>
          {getRemoteString({
            key: 'early.recap.performance.negative_gain.drawer.body',
          })}
        </ModalText>
      </ModalContent>
    </StyledModalDrawer>
  )
}
